<template>
  <div class>
    <Loading v-if="loading" loadingString="Import Passwords" />
    <div id="mainDiv" class="container roundedBorder secondary-bg primary-fg">
      <h2>Import Passwords</h2>
      <h5>
        In order to import your passwords from
        <b class="secondary-fg">Google</b>
      </h5>
      <h6>
        <ul class="browser-default">
          <li>
            Go to
            <a href="https://passwords.google.com" target="blank"
              >passwords.google.com</a
            >
          </li>
          <li>Sign in to your google account</li>
          <li>
            Click to the
            <span class="secondary-fg">
              cog icon
              <i class="material-icons">settings</i>
              (passwords options)
            </span>
            that is located at the top-right corner
          </li>
          <li>
            Click to the
            <span class="secondary-fg">
              export
              <i class="material-icons">file_upload</i>
            </span>
            button
          </li>
          <li>
            Download the
            <span class="secondary-fg">Google Passwords.csv</span>
            file to your computer
          </li>
        </ul>
      </h6>
      <div class="file-field input-field">
        <div class="btn primary-bg">
          <span>Upload Google Passwords.csv</span>
          <input
            v-on:input="file = $event.target.files[0];"
            type="file"
            class="white-text"
          />
        </div>
        <div class="file-path-wrapper">
          <input class="file-path validate" type="text" />
        </div>
      </div>
      <a
        :class="{ disabled: !file }"
        v-on:click="completeButtonClicked"
        class="waves-effect waves-light btn primary-bg"
      >
        <i class="material-icons left">done</i>Complete
      </a>
    </div>

    <!-- Modal structure -->
    <div id="modal" class="modal">
      <div class="modal-content">
        <h4>{{modalTitle}}</h4>
        <p>{{modalDescription}}</p>
      </div>
      <div class="modal-footer">
        <router-link class="modal-close waves-effect btn-flat blue-text" to="/passwords">Go to Passwords</router-link>      
        <a href="#!" class="modal-close waves-effect btn-flat blue-text">Okay</a>
      </div>
    </div>


  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import M from "materialize-css";
import Loading from "../components/Loading.vue";

// eslint-disable-next-line
const IMPORT_PASSWORDS_API_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "/api/passwords/import/google"
    : "http://localhost:7777/api/passwords/import/google";

export default {
  name: "ImportPasswords",
  components: {
    Loading,
  },
  data: function () {
    return {
      loading: true,
      file: false,
      modalTitle: '',
      modalDescription: ''
    };
  },
  methods: {
    displayModal: function(title, description){

        this.modalTitle = title
        this.modalDescription = description

        // Show the modal
        let editModal = document.querySelector("#modal");
        M.Modal.getInstance(editModal).open();
    },
    completeButtonClicked: async function () {
        let reader = new FileReader()
        reader.readAsText(this.file, 'utf-8')
        reader.onload = async () => {
            // Successfully read the file, now send this data to the
            // back-end server

            // Concat the first line of the csvContent (headers)
            let csvContent = reader.result.split('\n')
            csvContent.shift()
            csvContent = csvContent.join('\n')
            
            let idToken = await this.getIdToken()
            const options = {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                Authorization: idToken,
                },
                body: JSON.stringify({
                    csv: csvContent
                }),
            };
            let serverResponse = await fetch(IMPORT_PASSWORDS_API_ENDPOINT, options).then(
                (res) => {
                    return res.json();
                }
            ).catch((error)=>{
              this.displayModal(
                  'Oops', 
                  `Failed while importing the passwords: ${error}`
                )
                return;
            })
            if (!serverResponse.success) {
                this.displayModal(
                  'Oops', 
                  `Failed while importing the passwords: ${serverResponse.data}`
                )
                return;
            }
            else{
                this.displayModal(
                    'Successfully Completed Importing', 
                    'Your passwords are now stored within LockerApp!'
                )
            }
            
        }
        reader.onerror = () => {
            this.displayModal(
              'Oops', 
              `Failed while reading the file:${reader.error}`
            )
        }
    },
    getIdToken: async function () {
      let idToken = await firebase
        .auth()
        .currentUser.getIdToken(false)
        .then(function (idToken) {
          return idToken;
        })
        .catch(function (error) {
          // Handle error
          console.error(
            `Failed while fetching the idToken from the firebase: ${error.meesage}`
          );
        });

      return idToken;
    },
  },
  mounted: function () {
    // If there is no user navigate to the root page
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
      return;
    }

    this.loading = false;

    // Initialize the materialize components
    // This also closes the navbar if open
    M.AutoInit();
  },
  metaInfo: {
    title: "Import Passwords",
    meta: [
      {
        name: "description",
        content: "Import all of your passwords to the LockerApp",
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Locker App, Locker, App, Import, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application",
      },
    ],
  },
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}
ul {
  margin: 0;
}
li {
  line-height: 36px;
}
.input-field [type="text"] {
  color: var(--primary-fg-color);
}
</style>
